import styled from "@emotion/styled";
import { nonSelectable, notDraggable } from "@src/utils/styles";

export const Img = styled.img`
  ${nonSelectable}
  ${notDraggable}
`;
